module.exports = __webpack_public_path__ + "static/media/logo.8c9124c5.png";